// review.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ReviewData } from '../models';


@Injectable({
  providedIn: 'root'
})
export class ReviewService {
  // Replace with your Cloudflare Worker URL
  private apiUrl = environment.apiBaseUrl + '/review';
  private productHash: string = '';
  private currentLink: string = '';

  constructor(private http: HttpClient) { }

  // Generate base62 hash from link (first 10 characters)
  private generateProductHash(link: string): string {
    const base62Chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    let hash = '';

    // Create a stable numeric hash
    let numHash = 0;
    for (let i = 0; i < link.length; i++) {
      numHash = ((numHash << 5) - numHash) + link.charCodeAt(i);
      numHash |= 0; // Ensure 32-bit integer
    }

    // Convert to positive number
    numHash = Math.abs(numHash);

    // Convert to base62 string
    while (numHash > 0) {
      hash = base62Chars[numHash % 62] + hash;
      numHash = Math.floor(numHash / 62);
    }

    // Ensure length 10 deterministically by padding or truncating
    if (hash.length < 10) {
      hash = hash.padStart(10, base62Chars[hash.length % 62]);
    } else if (hash.length > 10) {
      hash = hash.substring(0, 10);
    }

    return hash;
  }

  // Initialize with link - call this once on component init
  setLink(link: string): void {
    this.currentLink = link;
    this.productHash = this.generateProductHash(link);
  }

  // Setter for productHash if needed
  setProductHash(hash: string): void {
    this.productHash = hash;
  }

  // Getter for productHash
  getProductHash(): string {
    return this.productHash;
  }

  // Getter for current link
  getCurrentLink(): string {
    return this.currentLink;
  }

  getReview(): Observable<ReviewData> {
    if (!this.productHash) {
      throw new Error('ProductHash not initialized. Call setLink() first.');
    }
    return this.http.get<ReviewData>(`${this.apiUrl}/${this.productHash}`);
  }

  updateReview(data: Partial<ReviewData>): Observable<ReviewData> {
    if (!this.productHash) {
      throw new Error('ProductHash not initialized. Call setLink() first.');
    }
    return this.http.post<ReviewData>(`${this.apiUrl}/${this.productHash}`, data);
  }

  incrementView(): Observable<ReviewData> {
    if (!this.productHash) {
      throw new Error('ProductHash not initialized. Call setLink() first.');
    }
    return this.http.put<ReviewData>(`${this.apiUrl}/${this.productHash}/view`, {});
  }

  incrementLike(): Observable<ReviewData> {
    if (!this.productHash) {
      throw new Error('ProductHash not initialized. Call setLink() first.');
    }
    return this.http.put<ReviewData>(`${this.apiUrl}/${this.productHash}/like`, {});
  }
}